export const RSS_FEED_DEFAULTS = {
  imageBorderRadius: '8px',
  titleFontSize: 24,
  titleFontFamily: 'Inter',
  subtitleFontSize: 14,
  subtitleFontFamily: 'Inter',
  titleTextColor: 'inherit',
  subtitleTextColor: 'inherit',
  titleFontWeight: 700,
  subtitleFontWeight: 400,
  borderRadius: '8px',
  borderWidth: '1px',
  borderColor: 'inherit',
  borderStyle: 'none',
  background: 'transparent',
};

export const RSS_FEED_EPISODE_DEFAULTS = {
  pageWidth: '1100px',
  pageWidthMax: '100%',
  pageBackgroundColor: 'white',
  pageGap: '64px',
  imageBorderRadius: '16px',
  titleFontSize: 30,
  titleFontFamily: 'Inter',
  titleTextColor: 'inherit',
  titleFontWeight: 700,
  descriptionFontWeight: 400,
  descriptionTextColor: 'inherit',
  descriptionFontSize: 18,
  descriptionFontFamily: 'Inter',
  dateFontSize: 12,
  dateFontFamily: 'Inter',
  dateTextColor: 'inherit',
  dateFontWeight: 400,

  contentFontSize: 16,
  contentFontFamily: 'Inter',
  contentTextColor: 'inherit',
  contentFontWeight: 400,
};

interface CardStructureOptions {
  imageAspectRatio: number;
}

export const BUILD_RSS_FEED_DEFAULT_CARD_STRUCTURE = (
  options: CardStructureOptions = {
    imageAspectRatio: 1,
  },
) => ({
  type: 'doc',
  attrs: {
    id: null,
    data: {},
    pageId: null,
    lp_name: '',
    deletable: true,
    appliedThemeId: null,
    backgroundColor: 'transparent',
  },
  content: [
    {
      type: 'container',
      attrs: {
        id: null,
        gap: '8px',
        top: '0px',
        blur: '0px',
        left: '0px',
        right: '0px',
        width: '100%',
        bottom: '0px',
        margin: '0px 0px 0px 0px',
        shadow: 'none',
        tokens: {},
        zIndex: 'auto',
        lp_name: 'Podcast Card',
        padding: '0px 0px 0px 0px',
        flexWrap: 'nowrap',
        mergeTag: null,
        overflow: 'hidden',
        position: 'relative',
        deletable: true,
        textAlign: 'left',
        width_max: '100%',
        borderColor: 'transparent',
        borderStyle: 'none',
        borderWidth: '0px',
        borderRadius: '8px',
        overlayColor: '#000000',
        flexDirection: 'column',
        stackOnMobile: true,
        verticalAlign: 'align_start',
        appliedThemeId: null,
        backgroundColor: '#ffffff',
        horizontalAlign: 'center',
        backgroundDarken: false,
        centerVertically: false,
        positionTopActive: true,
        centerHorizontally: false,
        positionLeftActive: false,
        mobileFlexDirection: 'column',
        positionRightActive: true,
        positionBottomActive: false,
      },
      content: [
        {
          type: 'image',
          attrs: {
            id: null,
            alt: 'Episode artwork',
            src: 'https://placehold.co/600x600/e5e7eb/9ca3af?text=Episode+Art',
            top: '0px',
            url: '',
            left: '0px',
            align: 'center',
            right: '0px',
            title: '',
            width: 64,
            bottom: '0px',
            height: 64,
            source: null,
            target: null,
            tokens: {},
            gridGap: 16,
            lp_name: 'Episode Image',
            padding: '0px',
            mergeTag: 'podcast.episode.image',
            position: 'relative',
            boxShadow: 'none',
            objectFit: 'cover',
            captionUrl: '',
            aspectRatio: options.imageAspectRatio,
            borderColor: '#E5E7EB',
            borderStyle: 'none',
            borderWidth: '0px',
            isFullWidth: true,
            borderRadius: '8px 8px 8px 8px',
            captionAlign: 'center',
            captionTarget: null,
            galleryLayout: 'carousel',
            internal_link: false,
            mobileGridGap: 8,
            appliedThemeId: null,
            galleryColumns: '2',
            carouselVariant: 'arrows-dots-bottom',
            open_in_new_tab: false,
            secondaryImages: [],
            thumbnailHeight: 80,
            carouselDotColor: '#FFFFFF66',
            centerVertically: false,
            positionTopActive: true,
            thumbnailPosition: 'bottom',
            carouselArrowColor: '#FF005AFF',
            centerHorizontally: false,
            positionLeftActive: false,
            positionRightActive: true,
            positionBottomActive: false,
            thumbnailBorderRadius: '8px',
            carouselArrowIconColor: '#ffffff',
            carouselDotActiveColor: '#FFFFFFFF',
            gridFirstImageFullWidth: false,
            carouselCounterTextColor: '#FFFFFFFF',
            mobileThumbnailBorderRadius: '6px',
            carouselCounterBackgroundColor: '#11182780',
          },
        },
        {
          type: 'container',
          attrs: {
            id: null,
            gap: '8px',
            top: '0px',
            blur: '0px',
            left: '0px',
            right: '0px',
            width: '100%',
            bottom: '0px',
            height: 'stretch',
            margin: '0px 0px 0px 0px',
            shadow: 'none',
            tokens: {
              backgroundColor: 'disabled',
            },
            zIndex: 'auto',
            lp_name: 'Content',
            padding: '0px 0px 0px 0px',
            flexWrap: 'nowrap',
            mergeTag: null,
            overflow: 'visible',
            position: 'relative',
            deletable: true,
            textAlign: 'left',
            width_max: '100%',
            borderColor: 'transparent',
            borderStyle: 'none',
            borderWidth: '0px',
            borderRadius: '0px',
            overlayColor: '#000000',
            flexDirection: 'column',
            stackOnMobile: true,
            verticalAlign: 'align_start',
            appliedThemeId: null,
            backgroundColor: 'transparent',
            horizontalAlign: 'left',
            backgroundDarken: false,
            centerVertically: false,
            positionTopActive: true,
            centerHorizontally: false,
            positionLeftActive: false,
            mobileFlexDirection: 'column',
            positionRightActive: true,
            positionBottomActive: false,
          },
          content: [
            {
              type: 'heading',
              attrs: {
                id: null,
                top: '0px',
                left: '0px',
                level: 3,
                right: '0px',
                width: '100%',
                bottom: '0px',
                tokens: {
                  color: 'text_on_background_color',
                },
                lp_name: 'Title',
                padding: '0px 0px 0px 0px',
                maxWidth: '100%',
                mergeTag: 'podcast.episode.title',
                position: 'relative',
                deletable: true,
                textAlign: 'left',
                borderColor: 'inherit',
                borderStyle: 'none',
                borderWidth: '0px',
                borderRadius: '0px',
                letterSpacing: '0px',
                textTransform: 'none',
                appliedThemeId: null,
                lineClampClass: 'line-clamp-2',
                lineHeight: 'inherit',
                backgroundColor: 'transparent',
                centerVertically: false,
                positionTopActive: true,
                centerHorizontally: false,
                positionLeftActive: false,
                strikethroughColor:
                  'color-mix(in srgb, var(--color-text-primary, var(--wt-primary-color, #6B7280)) 50%, transparent)',
                positionRightActive: true,
                positionBottomActive: false,
              },
              content: [
                {
                  text: 'Episode Title Goes Here',
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'inherit',
                        tokens: {
                          color: 'disabled',
                          fontFamily: 'body_font',
                        },
                        fontSize: '24px',
                        fontFamily: 'Instrument Sans',
                        fontWeight: null,
                        fontGradient: null,
                        textTransform: null,
                        appliedThemeId: null,
                        hoverTextColor: null,
                        mobileFontSize: null,
                        hoverDecorationLine: null,
                        hoverDecorationColor: null,
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: {
                id: null,
                top: '0px',
                left: '0px',
                right: '0px',
                width: '100%',
                bottom: '0px',
                tokens: {
                  color: 'text_on_background_color',
                },
                lp_name: 'Date',
                padding: '0px 0px 0px 0px',
                maxWidth: '100%',
                mergeTag: 'podcast.episode.publish_date',
                position: 'relative',
                deletable: true,
                textAlign: 'left',
                borderColor: 'inherit',
                borderStyle: 'none',
                borderWidth: '0px',
                postAuthors: [],
                postTagsGap: '4px',
                borderRadius: '0px',
                postPaidText: '',
                letterSpacing: '0px',
                textTransform: 'none',
                appliedThemeId: null,
                lineClampClass: '',
                lineHeight: 'inherit',
                postAuthorsGap: '4px',
                backgroundColor: 'transparent',
                centerVertically: false,
                postPaidIconFill: '#030712',
                positionTopActive: true,
                postAuthorsByLine: '',
                centerHorizontally: false,
                positionLeftActive: false,
                postPaidContentGap: '4px',
                postReadTimeSuffix: 'min read',
                strikethroughColor:
                  'color-mix(in srgb, var(--color-text-primary, var(--wt-primary-color, #6B7280)) 50%, transparent)',
                positionRightActive: true,
                positionBottomActive: false,
                postAuthorsImageSize: '24px',
                postTimestampDisplay: 'short_date',
                postAuthorsImagesFill: 'inherit',
                postAuthorsTextEnabled: true,
                postPaidContentIconSize: 16,
                postAuthorsImagesEnabled: true,
                postTagsTruncateListEnabled: true,
                postAuthorsTruncateListEnabled: false,
              },
              content: [
                {
                  text: 'Jan 15, 2025',
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'inherit',
                        tokens: {
                          color: 'disabled',
                          fontFamily: 'body_font',
                        },
                        fontSize: '14px',
                        fontFamily: 'Instrument Sans',
                        fontWeight: null,
                        fontGradient: null,
                        textTransform: null,
                        appliedThemeId: null,
                        hoverTextColor: null,
                        mobileFontSize: null,
                        hoverDecorationLine: null,
                        hoverDecorationColor: null,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});
